var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.757812,
    y: 1.46875,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#264C86"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2578 17.9688H10.2578C9.97448 17.9688 9.73715 17.8728 9.54582 17.6808C9.35448 17.4888 9.25848 17.2514 9.25782 16.9688C9.25715 16.6861 9.35315 16.4488 9.54582 16.2568C9.73848 16.0648 9.97582 15.9688 10.2578 15.9688H15.2578V10.9688C15.2578 10.6854 15.3538 10.4481 15.5458 10.2568C15.7378 10.0654 15.9751 9.96942 16.2578 9.96875C16.5405 9.96809 16.7781 10.0641 16.9708 10.2568C17.1635 10.4494 17.2591 10.6868 17.2578 10.9688V15.9688H22.2578C22.5412 15.9688 22.7788 16.0648 22.9708 16.2568C23.1628 16.4488 23.2585 16.6861 23.2578 16.9688C23.2571 17.2514 23.1611 17.4891 22.9698 17.6818C22.7785 17.8744 22.5412 17.9701 22.2578 17.9688H17.2578V22.9688C17.2578 23.2521 17.1618 23.4898 16.9698 23.6818C16.7778 23.8738 16.5405 23.9694 16.2578 23.9688C15.9751 23.9681 15.7378 23.8721 15.5458 23.6808C15.3538 23.4894 15.2578 23.2521 15.2578 22.9688V17.9688Z",
    fill: "#264C86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.5ece8a8dbff3debe1b3510491b31f4fe.svg";
export { ForwardRef as ReactComponent };